import { useUserStore } from "@stores/index";

export const useBusinessType = (businessId: string) => {
  const businesses = useUserStore(({ businesses }) => businesses);
  const businessType = businesses.find(
    ({ uniqueId }) => uniqueId === businessId,
  )?.type;
  return businessType;
};
